import { defineMessages } from 'react-intl';

import { messages as scheduleListItemMessages } from '../ScheduleList/ScheduleListItem.messages';

const v2Messages = defineMessages({
  addSpotLink: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.add-spot-link',
    defaultMessage: 'Add spot',
  },
  addSpotsLink: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.add-spots-link',
    defaultMessage: 'Add {count, number} {count, plural, one {spot} other {spots}}',
  },
  badgeNew: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.badge-new',
    defaultMessage: '{count, number} new',
  },
  badgeNewTooltip: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.badge-new-tooltip',
    defaultMessage:
      '{count, plural, one {# client is new to your business.} other {# clients are new to your business.}}',
  },
  badgeSmartspotOff: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.badge-smartspot-off',
    defaultMessage: 'SmartSpot is off',
  },
  badgeWaiting: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.badge-waiting',
    defaultMessage: '{count, number} waiting',
  },
  badgeWaitingTooltip: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.badge-waiting-tooltip',
    defaultMessage:
      '{count, plural, one {# client is waiting to be notified when spots open up.} other {# clients are waiting to be notified when spots open up.}}',
  },
  classpassFullTooltip: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.classpass-full-tooltip',
    defaultMessage: 'Your ClassPass spots are fully booked! Add more spots to increase capacity.',
  },
  durationMinutes: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.duration-minutes',
    defaultMessage: '{duration, number} min',
  },
  fillBarCount: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.fill-bar-count',
    defaultMessage: '{classpassBooked, number}/{classpassAllocated, number}',
  },
  fillBarDirectCount: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.fill-bar-direct-count',
    defaultMessage: '{directBooked, number}',
  },
  fillBarLabelClasspass: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.fill-bar-label-classpass',
    defaultMessage: 'CP {count}',
  },
  fillBarLabelDirect: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.fill-bar-label-direct',
    defaultMessage: 'Direct {count}',
  },
  fillBarLabelManual: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.fill-bar-label-manual',
    defaultMessage: 'CP bookings {count}',
  },
  noInstructor: {
    id: 'yield-management.schedule-list-v2.schedule-list-item.no-instructor',
    defaultMessage: 'No instructor specified',
  },
});

export const messages = {
  ...v2Messages,
  isCancelled: scheduleListItemMessages.isCancelled,
  isDisabled: scheduleListItemMessages.isDisabled,
  reservationsStopped: scheduleListItemMessages.reservationsStopped,
};
